import { render } from "./ClinicalNote.vue?vue&type=template&id=c8432d00&scoped=true"
import script from "./ClinicalNote.vue?vue&type=script&lang=js"
export * from "./ClinicalNote.vue?vue&type=script&lang=js"

import "./ClinicalNote.vue?vue&type=style&index=0&id=c8432d00&scoped=true&lang=scss"
import "./ClinicalNote.vue?vue&type=style&index=1&id=c8432d00&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8432d00"]])

export default __exports__